import { updateRequestContants } from "../constant/updateRequest.contants";

export const initState = {
    errorCode: "",
    isLoading: true,
    isError: false,
};

const updateRequestReducer = (state = initState, action) => {
    switch (action.type) {
        case updateRequestContants.UPDATE_SUCCESS:
            return {
                ...state,
                errorCode: action.code,
                isLoading: false,
                isError: false,
            };
        case updateRequestContants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.code,
                isLoading: false,
                isError: true,
            };
        default:
            return {
                ...state,
            };
    }
};

export default updateRequestReducer;
